import { useMediaQuery } from "@material-ui/core";

export const useColsGridList = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("xs"));
  const isTablet = useMediaQuery(theme => theme.breakpoints.only("sm"));
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up("md"));

  if (isDesktop) {
    return 7;
  } else if (isTablet) {
    return 4;
  } else if (isMobile) {
    return 1;
  }
};
